import React, { useState, useEffect, useRef } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Typography from '../../../../../UniformComponents/Typography'
import Input from '../../../../form/Input'
import Button from '../../../../../UniformComponents/Button'
import './aiAssistant.scss'

// TODO later
// [ ] use data from backend
// [ ] store chatHistory in sessionStorage (?)

const AiChat = observer(({ reportStore }) => {
    // const { chatHistory, sendMessage, isChatAvailable } = reportStore
    const [currentMsg, setCurrentMsg] = useState('')
    const messagesEndRef = useRef(null)

    const mockChatHistory = {
        id: '123',
        messages: [
            {
                role: 'assistant',
                date: Date.now(),
                text: i18n.t('s_report_ai_chat_greeting'),
            },
            {
                role: 'user',
                date: Date.now(),
                text: 'Hi',
            },
            {
                role: 'user',
                date: Date.now(),
                text: 'What is the overall satisfaction score for this event?',
            },
            {
                role: 'assistant',
                date: Date.now(),
                text: 'Based on the report data, the average satisfaction score is 4.38 out of 5, with 80% of respondents indicating strong engagement. The "Very satisfied" category received 56.78% of responses.',
            },
        ],
    }
    const chatHistory = mockChatHistory
    const isChatAvailable = true

    const handleSendMessage = () => {
        const trimmed = currentMsg.trim()
        if (trimmed.length > 1) {
            console.log('Sending message:', currentMsg)
            setCurrentMsg('')
        }
    }

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
    }

    useEffect(() => {
        scrollToBottom()
    }, [chatHistory.messages])

    return (
        <div className="ai-panel-content chat">
            <div className="section-header">
                <div className="section-title">
                    <i className="fal fa-robot" />
                    <Typography type="h4">{i18n.t('s_report_ai_chat_ask')}</Typography>
                </div>
            </div>

            <div className="section-body chat">
                <div className="messages">
                    {chatHistory.messages.map((m, i) => (
                        <div key={i} className={`message-wrapper ${m.role}`}>
                            {m.role === 'assistant' && <i className="fal fa-robot" />}
                            <div className="message">
                                <Typography type="p">{m.text}</Typography>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="chat-input-container">
                    <Input
                        type="text"
                        placeholder={i18n.t('s_report_ai_chat_placeholder')}
                        value={currentMsg}
                        onBlur={handleSendMessage}
                        onChange={(e) => setCurrentMsg(e.value)}
                        disabled={!isChatAvailable}
                        hideLabel
                    />
                    <Button
                        icon="far fa-paper-plane-top"
                        cssClass="regular tertiary send-button"
                        onClick={handleSendMessage}
                        disabled={!isChatAvailable || !currentMsg.trim()}
                    />
                </div>
            </div>
        </div>

    )
})

export default AiChat
